import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const entityBoardStyleId = 'wb-v2-entity-board-theme';

export const entityBoardBridgeStyles = {
  'entity-board': {
    '--local-entity-board-compact-background': tokens.color.background.primary,
    '--local-entity-board-compact-gutter': tokens.spacing.none,
    '--local-entity-board-compact-border': tokens.color.border.secondary,
    // Gray canvas inset above the grid when the paging strip is off. Table/list L/R match this.
    '--local-entity-board-display-pad-block-start': tokens.spacing.xl,
  },
};
